import 'react-datepicker/dist/react-datepicker.css';

import moment from 'moment';
import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import { Button, Modal, ModalBody, Row } from 'reactstrap';

import calendar from '../../../assets/img/calendar.svg';
import CircularLoading from '../../Common/CircularLoading/CircularLoading';
import FormFeedback from '../../Common/FormFeedback/FormFeedback';

function ChapterStudyPlanModal({
  isOpen,
  onClose,
  buildChapterStudyPlan,
  buildChapterStudyPlanLoading,
}) {
  const [startDate, setStartDate] = useState(null);
  const [examDate, setExamDate] = useState(null);
  const [showErrors, setShowErrors] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  // Close once the build finishes
  useEffect(() => {
    if (submitted && !buildChapterStudyPlanLoading) {
      setSubmitted(false);
      onClose();
    }
  }, [buildChapterStudyPlanLoading, submitted]);

  const getTomorrow = () => {
    const d = new Date();
    d.setDate(d.getDate() + 1);
    return d;
  };

  const handleSubmit = () => {
    setShowErrors(true);
    if (!startDate || !examDate) return;
    setSubmitted(true);
    buildChapterStudyPlan(moment(startDate), moment(examDate));
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={!buildChapterStudyPlanLoading ? onClose : undefined}
      className="study-popup m-auto"
      centered
    >
      <ModalBody>
        <Row className="m-0">
          <button
            type="button"
            className="close"
            aria-label="Close"
            onClick={onClose}
            disabled={buildChapterStudyPlanLoading}
          >
            <span aria-hidden="true">×</span>
          </button>
          <div className="col-sm-12 col-md-6 bg-primary text-center p-0 d-flex align-items-center">
            <div className="date-wrapper">
              <div className="blue-circle">
                <img src={calendar} alt="calendar" height="84" width="81" />
              </div>
              <h2>Build your Chapter Study Plan!</h2>
              <div className="row">
                <div className="col-12 col-sm-6 date-selector">
                  <label htmlFor="start_date" className="study__start__title">
                    STUDY START DATE
                  </label>
                  <DatePicker
                    id="start_date"
                    showIcon
                    popperPlacement="top-start"
                    selected={startDate}
                    dateFormat="MM/dd/yyyy"
                    minDate={new Date()}
                    onChange={setStartDate}
                    className="datepicker-input-text"
                    wrapperClassName="datepicker-input"
                  />
                  <FormFeedback
                    show={!startDate && showErrors}
                    text="Please enter a study start date"
                  />
                </div>
                <div className="col-12 col-sm-6 date-selector">
                  <label htmlFor="exam_date">ESTIMATED EXAM DATE</label>
                  <DatePicker
                    id="exam_date"
                    showIcon
                    popperPlacement="top-end"
                    selected={examDate}
                    dateFormat="MM/dd/yyyy"
                    minDate={getTomorrow()}
                    onChange={setExamDate}
                    className="datepicker-input-text"
                    wrapperClassName="datepicker-input"
                  />
                  <FormFeedback
                    show={!examDate && showErrors}
                    text="Please enter an estimated exam date"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="chapter-study-plan-modal col-sm-12 col-md-6 pr-0 my-auto">
            <div className="pt-4 pr-4 pl-2 pb-4">
              <h2 className="mb-1 mt-1 primary">Chapter Study Plan</h2>
              <p>
                We'll build a weekly schedule from your selected chapters based
                on your start date and exam date.
              </p>
              <Button
                color="primary"
                onClick={handleSubmit}
                disabled={buildChapterStudyPlanLoading}
                block
              >
                {buildChapterStudyPlanLoading ? (
                  <CircularLoading className="loading-gif-waiting" />
                ) : (
                  'BUILD PLAN'
                )}
              </Button>
            </div>
          </div>
        </Row>
      </ModalBody>
    </Modal>
  );
}

export default ChapterStudyPlanModal;
